import React from "react";
import NotAccess from "../../components/common/userNotAccess/index";
import { IsShowCreateOrder } from "../../utils";

function RestrictCreateOrder(props) {
  if (IsShowCreateOrder()) return props.children;
  return <NotAccess />;
}

export default RestrictCreateOrder;
